import React from "react";

//Almond photo shown above the footer on the inner pages
const PhotoStrip = () => (
  <span
    className={"photo-strip"}
    style={{ "--bg-image": "url(/images/almonds.jpg)" }}
    aria-hidden={"true"}
  />
);

export default PhotoStrip;
